export default __webpack_public_path__ + "static/media/home_banner.4a0285aa.png";